var _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateNoTemplates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2205 133.012C35.1746 86.2622 60.689 85.032 74.6741 86.2622C143.101 92.2817 175.067 118.864 188.552 128.706C225.513 155.68 233.504 213.884 147.596 208.672C46.2045 202.521 28.7231 162.538 31.2205 133.012Z",
    fill: "url(#paint0_linear_18906_44005)",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2932 109.771C5.73658 95.9097 12.2082 89.7017 14.2975 88.1216C23.4395 81.5361 36.3229 80.3318 34.1737 93.1238C32.0246 105.916 16.8498 123.632 11.2932 109.771Z",
    fill: "url(#paint1_linear_18906_44005)",
    fillOpacity: 0.15
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.966,
    cy: 117.334,
    rx: 8.29295,
    ry: 11.6101,
    transform: "rotate(165.313 219.966 117.334)",
    fill: "url(#paint2_linear_18906_44005)",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.625 74.625V115.292H115.292V74.625H74.625ZM72.0833 67C69.2759 67 67 69.2759 67 72.0833V117.833C67 120.641 69.2759 122.917 72.0833 122.917H117.833C120.641 122.917 122.917 120.641 122.917 117.833V72.0833C122.917 69.2759 120.641 67 117.833 67H72.0833Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7083 140.708V176.292H115.292V140.708H79.7083ZM77.1667 133.083C74.3592 133.083 72.0833 135.359 72.0833 138.167V178.833C72.0833 181.641 74.3592 183.917 77.1667 183.917H117.833C120.641 183.917 122.917 181.641 122.917 178.833V138.167C122.917 135.359 120.641 133.083 117.833 133.083H77.1667Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.708 79.7083V115.292H176.292V79.7083H140.708ZM138.167 72.0833C135.359 72.0833 133.083 74.3592 133.083 77.1667V117.833C133.083 120.641 135.359 122.917 138.167 122.917H178.833C181.641 122.917 183.917 120.641 183.917 117.833V77.1667C183.917 74.3592 181.641 72.0833 178.833 72.0833H138.167Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.708 140.708V181.375H181.375V140.708H140.708ZM138.167 133.083C135.359 133.083 133.083 135.359 133.083 138.167V183.917C133.083 186.724 135.359 189 138.167 189H183.917C186.724 189 189 186.724 189 183.917V138.167C189 135.359 186.724 133.083 183.917 133.083H138.167Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.5 33C112 33 97.5 56.5 91.5 70.5C84 88 83 134.499 91.5 156.999C100 179.499 112 202.499 138 213.999C164 225.499 215.364 220.999 224.5 187.499C232 159.999 222.618 100.982 202.999 75C184.499 50.5 168 33 134.5 33ZM141.5 86C155.583 86 167 76.3741 167 64.5C167 52.6259 155.583 43 141.5 43C127.417 43 116 52.6259 116 64.5C116 76.3741 127.417 86 141.5 86Z",
    fill: "currentColor",
    fillOpacity: 0.07
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18906_44005",
    x1: 116.446,
    y1: 202.486,
    x2: 71.4982,
    y2: 73.4823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18906_44005",
    x1: 31.7252,
    y1: 101.53,
    x2: 5.91924,
    y2: 107.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18906_44005",
    x1: 219.375,
    y1: 127.714,
    x2: 206.371,
    y2: 109.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNoTemplates);
export default __webpack_public_path__ + "static/media/emptyStateNoTemplates.90c192eb.svg";
export { ForwardRef as ReactComponent };